/**
 * Dialog messages for MOPT (Manufacturer-sourced Product Type) restrictions
 *
 * These messages are displayed in the MOPTRestrictionDialog when users
 * attempt actions that violate MOPT content restrictions.
 */
export const MOPT_RESTRICTION_MESSAGES = {
    /** Message shown when attempting to add content under a MOPT article */
    ADD: {
        title: 'Add Disabled',
        description:
            'Content cannot be added under a Manufacturer-sourced Product Type.',
    },
    /** Message shown when attempting to move/reorder content within MOPT articles */
    MOVE: {
        title: 'Move Disabled',
        description:
            'Content cannot be moved within a Manufacturer-sourced Product Type.',
    },
} as const

/**
 * Tooltip text for MOPT-related UI elements
 *
 * Used in hover tooltips to inform users about MOPT restrictions
 * before they attempt restricted actions.
 */
export const MOPT_TOOLTIP_TEXT = {
    /** Tooltip shown on the Add icon when hovering over MOPT article children */
    RESTRICTION: 'Cannot add content under Manufacturer Option articles',
} as const
